export const COLORS = {
  DS_DARK_GRAY: '#1f1f1f',
  DS_DARK_GREEN_BASE: '#146a59',
  DS_DARK_GREEN_LIGHT: '#69a095',
  DS_GRAY_TWO: '#666666',
  DS_GREEN: '#13682b',
  DS_GREEN_FIVE: '#427c37',
  DS_GRAY: '#3d3d3d',
  DS_GRAY_92: '#ebebeb',
  DS_GRAY_98: '#fafafa',
  DS_MEDIUM_GREEN_BASE: '#5bac4d',
  DS_MEDIUM_GREEN_DARK: '#427c37',
  DS_PINK_LIGHT: '#c5629c',
  DS_PINK_DARK: '#760649',
  DS_RED_BASE: '#ff2710',
  DS_RED_THREE: '#b81c0c',
  DS_RED_DARK: '#b81c0c',
}

export const GRADIENTS = {
  DS_BLUE_LIGHT: {
    TO: '#0CB2B2',
    FROM: '#5DD5D5',
  },
  DS_PINK_DARK: {
    TO: '#A40965',
    FROM: '#CF68A5',
  },
  DS_BLUE_DARK: {
    TO: '#34158C',
    FROM: '#7D69B5',
  },
  DS_YELLOW: {
    TO: '#F7DB71',
    FROM: '#FAE8A4',
  },
  DS_BLACK: {
    TO: '#1F1F1F',
    FROM: '#666666',
  },
  DS_DARK_GREEN: {
    TO: '#0B480E',
    FROM: '#538C30',
  },
  DS_LIGHT_GREEN: {
    TO: '#689900',
    FROM: '#91D400',
  },
  DS_TEAL_GREEN: {
    TO: '#146A60',
    FROM: '#69A09D',
  },
  DS_BROWN: {
    TO: '#712F12',
    FROM: '#B56D3A',
  },
  DS_RED: {
    TO: '#B81C0C',
    FROM: '#FF7566',
  },
}

export const GRADIENTS2 = {
  BLUE_DARK: {
    TO: '#1857A1',
    FROM: '#65A0E4',
  },
  BLUE_LIGHT: {
    TO: '#65A0E4',
    FROM: '#4AE4F4',
  },
  GREEN_LIGHT: {
    TO: '#35C26D',
    FROM: '#7CE9AE',
  },
  PURPLE: {
    TO: '#664DAD',
    FROM: '#B886F9',
  },
  PINK: {
    TO: '#DB4FCD',
    FROM: '#FA8FDC',
  },
  SALMON: {
    TO: '#DC6D64',
    FROM: '#F2A49D',
  },
  RED: {
    TO: '#BF232C',
    FROM: '#E86575',
  },
  ORANGE: {
    TO: '#EF7E32',
    FROM: '#F8AE7D',
  },
  YELLOW: {
    TO: '#EABE3B',
    FROM: '#F8D980',
  },
  BLACK: {
    TO: '#1F1F1F',
    FROM: '#666666',
  },
}

export const GRADIENTS3 = {
  BLUE_LIGHT: {
    TO: '#0CB2B2',
    FROM: '#36DADA',
  },
  PINK: {
    TO: '#A40965',
    FROM: '#D83194',
  },
  PURPLE: {
    TO: '#34158C',
    FROM: '#6241BF',
  },
  YELLOW: {
    TO: '#CBAA2B',
    FROM: '#FCE282',
  },
  BLACK: {
    TO: '#1F1F1F',
    FROM: '#666666',
  },
  GREEN_DARK: {
    TO: '#0B480E',
    FROM: '#338137',
  },
  GREEN_LIGHT: {
    TO: '#689900',
    FROM: '#95CA25',
  },
  TEAL: {
    TO: '#146A60',
    FROM: '#379C90',
  },
  BROWN: {
    TO: '#712F12',
    FROM: '#AD6342',
  },
  RED: {
    TO: '#B81C0C',
    FROM: '#EE5949',
  },
}

export const ICON_SIZE = {
  SMALLEST: '12px',
  SMALL: '16px',
  DEFAULT: '32px',
}

export const INFO_BUTTON = {
  color: COLORS.GREEN,
  height: '24px',
  type: 'outline',
  width: '24px',
}

export const DROPDOWN_BUTTON = {
  color: COLORS.DS_DARK_GRAY,
  fontSize: '14px',
  fontWeight: 'normal',
  lineHeight: '24px',
  margin: '0 auto 8px 0',
  padding: '0',
}
